module.exports = __webpack_public_path__ + "img/mcu.2f0994ae.svg";